import React, { Component } from 'react';
import { Provider } from 'react-redux';
import store from './store'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faStar, faHeart, faPhone, faEnvelope, faSearch, faUtensils,
  faThumbsUp, faSortAlphaDown, faUserMinus, faDollarSign, faAngleDoubleRight, faPlus,
  faConciergeBell, faCommentAlt, faInfoCircle, faShoppingBasket, faTimes, faSpinner, faTruck, faTasks,
} from '@fortawesome/free-solid-svg-icons';

import 'bootstrap/dist/css/bootstrap.css';
import "./App.css"

import Navbar2 from './components/Navbar2'
import Navbar from './components/Navbar';
import MyRoutes from './config/routes'
import Footer from './components/Footer';

library.add(faStar, faHeart, faPhone, faEnvelope, faSearch, faUtensils,
  faThumbsUp, faSortAlphaDown, faUserMinus, faDollarSign, faAngleDoubleRight, faPlus,
  faConciergeBell, faCommentAlt, faInfoCircle, faShoppingBasket, faTimes, faSpinner, faTruck, faTasks,)

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        {/* <div>
          <MyRoutes />
        </div> */}
        <div>
          {/* Navbar (Header) */}
          <Navbar2 history={this.props.history} />

          {/* Main Routes */}
          <div style={{ minHeight: '80vh' }}>
            <MyRoutes />
          </div>

          {/* Footer */}
          <Footer />
        </div>
      </Provider>
    );
  }
}

export default App;